import type { VesselMessage } from "./types"

abstract class VesselError extends Error {
  public type = "VesselError"
  public abstract name: string
}

export class TimeoutError extends VesselError {
  public name = "TimeoutError"
  public postedMessage: VesselMessage
  public timeout: number
  public attempts: number
  constructor(postedMessage: VesselMessage, timeout: number, attempts = 1) {
    super(
      `Failed to receive response for message ${postedMessage.id} within ${timeout}ms. Payload: ${JSON.stringify(postedMessage.payload)}`,
    )
    this.postedMessage = postedMessage
    this.timeout = timeout
    this.attempts = attempts
  }
}

export class HandshakeTimeoutError extends TimeoutError {
  public name = "HandshakeTimeoutError"
  public attempts: number
  constructor(postedMessage: VesselMessage, timeout: number, attempts: number) {
    super(postedMessage, timeout)
    this.message = `Failed to receive handshake response within ${timeout}ms after ${attempts} attempts. Payload: ${JSON.stringify(postedMessage.payload)}`
    this.attempts = attempts
  }
}
